// Step ids double as keys into `onBoardingConfig`. The SCREAMING_SNAKE ids are
// the `screen_to_show` values returned by the onboarding APIs.
export const STEP = {
  landing: "landingPage",
  phone: "phoneNumber",
  loginEmail: "loginEmail",
  password: "existingPassword",
  otp: "verifyPhone",
  forgotOtp: "forgotPasswordOtp",
  setNewPassword: "setNewPassword",
  passwordUpdated: "passwordUpdated",
  details: "emailDetails",
  verifyEmail: "verifyEmail",
  fuelRequirements: "STAGE_2_ONBOARDING_FUEL_REQUIREMENTS",
  companyRole: "STAGE_2_ONBOARDING_COMPANY_ROLE",
  goals: "STAGE_2_ONBOARDING_GOALS_PAIN_POINTS",
  dieselIntro: "STAGE_3_DIESEL_PROCUREMENT_ASSESSMENT",
  procurementScore: "procurementScore",
  procurementResult: "procurementScoreResult",
  operationsScore: "STAGE_3_DIESEL_OPERATIONS_ASSESSMENT",
  operationsResult: "operationsScoreResult",
  dieselScore: "dieselScore",
  thanksInterest: "thanksInterest",
};
